/**
 * Helper puro: retorna true para qualquer modelo de disputa que possui uma
 * fase de grupos (GRUPOS_ELIMINACAO e GRUPO_UNICO). Retorna false para todos
 * os demais valores (incluindo null, undefined e strings desconhecidas).
 *
 * Centraliza o literal de guard que antes estava espalhado em
 * CategoryMatchesTab, TournamentCategoryPage, CategoryConfigTab e
 * GerarPartidasButton (anti-pattern de duplicação).
 *
 * Util puro: sem dependências de camadas superiores (componentes, services,
 * context). Pode ser importado por pages e components (direção permitida:
 * pages/components → utils).
 */
export const temFaseDeGrupos = (modelo?: string | null): boolean =>
  modelo === 'GRUPOS_ELIMINACAO' ||
  modelo === 'GRUPO_UNICO' ||
  modelo === 'REI_RAINHA' ||
  modelo === 'SUPER_8';
